import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const SAVI_LOGO = "https://customer-assets.emergentagent.com/job_184a0a73-7ed5-43f8-9a23-0cd69b83d3bb/artifacts/rcargp5m_no%20bkg.png";

// Standard portal top strip: [← back] [enso logo] Title ... right slot
const PortalHeader = ({ title, back = "/dashboard", right = null, testid = "portal-header", titleTestid, className = "" }) => (
  <header className={`sticky top-0 z-40 bg-[#FBF7F1]/85 backdrop-blur-xl border-b border-stone-200/60 ${className}`} data-testid={testid}>
    <div className="max-w-2xl mx-auto px-4 py-2.5 flex items-center gap-2">
      {back && (
        <Link
          to={back}
          className="p-1.5 -ml-1.5 text-[#1A1A1A]/60 hover:text-[#C85A38] flex-shrink-0 active:scale-[0.94] transition-transform"
          aria-label="Back"
          data-testid={`${testid}-back`}
        >
          <ArrowLeft className="w-5 h-5" strokeWidth={1.8} />
        </Link>
      )}
      <Link to="/dashboard" className="flex items-center gap-2.5 min-w-0" data-testid={`${testid}-home`}>
        <img src={SAVI_LOGO} alt="Savi" className="h-7 w-auto flex-shrink-0" />
        <h1 className="font-serif text-lg text-[#1A1A1A] truncate" data-testid={titleTestid}>{title}</h1>
      </Link>
      {right && <div className="ml-auto flex items-center gap-1 flex-shrink-0">{right}</div>}
    </div>
  </header>
);

export default PortalHeader;
